<template>
  <section id="my-projects-section">
    <div class="container flex flex-row flex-space-between flex-align-center">
      <div
        class="project-thumbnail-wrapper"
        v-if="this.$store.getters.getIsWebView"
      >
        <picture v-if="selectedProject">
          <source
            :srcset="require(`@/assets/images/project/${selectedProject}.webp`)"
            type="image/webp"
          />
          <source
            :srcset="require(`@/assets/images/project/${selectedProject}.png`)"
            type="image/png"
          />
          <img
            class="project-thumbnail"
            :src="require(`@/assets/images/project/${selectedProject}.png`)"
            alt="product-thumbnail"
            width="100%"
          />
        </picture>
      </div>
      <div class="projects-list-container">
        <h1 class="project-list__title">PROJECTS</h1>
        <div
          class="project-list text--align-left"
          @mouseenter="gExpandCursor"
          @mouseleave="gShrinkCursor"
        >
          <div
            class="project-list__project flex flex-space-between"
            v-for="project in projectList"
            :key="project.id"
            :id="project.id"
            @mouseenter="selectProject(project.img)"
          >
            <div
              :id="project.id + '-project__title'"
              class="project-list__project__title inline-flex flex-column"
            >
              <h3>
                {{ project.title }}
              </h3>
              <p class="project-list__project-role">{{ project.role }}</p>
            </div>
            <div class="project-list__project-score flex flex-row">
              <p>Performance {{ project.performance }}%</p>
              <p>
                Structure
                {{ project.structure }}%
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      selectedProject: "alpgw_web",
      projectList: [
        {
          id: 1,
          img: "alpgw_web",
          title: "ALPGW",
          performance: 98,
          structure: 100,
          role: "Project Lead",
        },
        // { img: "alpgw_web", title: "OSPACE", performance: 98, structure: 100 },
        {
          id: 2,
          img: "nuhs_balloon",
          title: "NUHS BALLOON",
          performance: 98,
          structure: 100,
          role: "Project Lead",
        },
        {
          id: 3,
          img: "nuhs_dalgona",
          title: "NUHS DALGONA",
          performance: 98,
          structure: 100,
          role: "Project Lead",
        },
        {
          id: 4,
          img: "nuhs_wordle",
          title: "NUHS WORDLE",
          performance: 98,
          structure: 100,
          role: "Project Lead",
        },
        {
          id: 5,
          img: "moonshot",
          title: "MOONSHOT",
          performance: 92,
          structure: 86,
          role: "Project Lead",
        },
        {
          id: 6,
          img: "queenswayAF",
          title: "ANYTIME FITNESS",
          performance: 98,
          structure: 98,
          role: "Project Lead",
        },
        {
          id: 7,
          img: "webbricks_web",
          title: "WEBBRICKSSG",
          performance: 100,
          structure: 98,
          role: "Project Lead",
        },
      ],
    };
  },
  methods: {
    selectProject(imgRoute) {
      this.selectedProject = imgRoute;
    },
  },
};
</script>
<style lang="scss" scoped>
.project-thumbnail-wrapper,
.projects-list-container {
  width: 45%;
  position: relative;
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
}
.project-list {
  height: 60vh;
  overflow-y: scroll;
  h3,
  p {
    display: inline;
    margin: 5px;
  }
}
.project-list__title {
  position: absolute;
  top: -100px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}
.project-list__project {
  padding: 20px 50px;
  border-top: 2px solid #e6e6e6;

  .project-list__project__title {
    width: auto;

    &:hover {
      animation: nudgeRight 500ms linear;
    }
  }
  .project-list__project-score {
    float: right;
    color: rgb(204, 204, 204);
    @media only screen and (min-width: 1281px) and (max-width: 1500px) {
      flex-direction: column;
    }
  }
  &:last-child {
    border-bottom: 2px solid #e6e6e6;
  }
}
@media only screen and (max-width: 1280px) {
  .project-list__project-score {
    flex-direction: row;
    font-size: 12px;
  }
  .project-list__project {
    flex-direction: column;
  }
}
.project-list__project-role {
  color: rgb(204, 204, 204);
}
@keyframes nudgeRight {
  0% {
    transform: translateX(+10px);
  }
  100% {
    transform: translateX(4px);
  }
}
</style>
